import { defineStore } from 'pinia';
import { CHANGELOG_ENTRIES } from '@/constants/changelog';

const STORAGE_KEY = 'mbportal_lastSeenChangelogVersion';

function loadLastSeenVersion() {
  try {
    return localStorage.getItem(STORAGE_KEY) || null;
  } catch (e) {
    return null;
  }
}

function saveLastSeenVersion(version) {
  try {
    if (version) {
      localStorage.setItem(STORAGE_KEY, version);
    }
  } catch (e) {
    // ignore storage errors (e.g. privacy mode)
  }
}

export const useChangelogStore = defineStore('changelog', {
  state: () => ({
    entries: CHANGELOG_ENTRIES,
    lastSeenVersion: loadLastSeenVersion(),
  }),
  getters: {
    latestVersion(state) {
      return state.entries[0]?.version || null;
    },
    unseenCount(state) {
      if (!state.entries.length) return 0;
      if (!state.lastSeenVersion) return state.entries.length;

      const idx = state.entries.findIndex(e => e.version === state.lastSeenVersion);
      if (idx === -1) return state.entries.length;
      return idx; // Einträge sind neueste zuerst
    },
    unseenVersions(state) {
      if (!state.entries.length) return [];
      if (!state.lastSeenVersion) return state.entries.map(e => e.version);

      const idx = state.entries.findIndex(e => e.version === state.lastSeenVersion);
      if (idx === -1) return state.entries.map(e => e.version);
      return state.entries.slice(0, idx).map(e => e.version);
    },
    hasUnseen() {
      return this.unseenCount > 0;
    },
  },
  actions: {
    markAllAsSeen() {
      const latest = this.latestVersion;
      if (!latest) return;
      this.lastSeenVersion = latest;
      saveLastSeenVersion(latest);
    },
    markVersionAsSeen(version) {
      if (!version) return;
      this.lastSeenVersion = version;
      saveLastSeenVersion(version);
    },
  },
});
